const footer = {
  counties: 'Serving Miami-Dade, Broward and Palm Beach',
  tollFreeNumber: '877 492 6278',
  email: 'info@ctchealthcare.com',
  webUrl: 'www.ctchealthcare.com',
  licenseNumber: 'NR# 30211118 / 30211096 / 42963834',
};
export default footer;
